import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, submit, startSubmit } from "redux-form";
import _ from "lodash";
import { Modal, Tabs, Tab } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import {
  BASE_IMAGES_URL,
  COMMON_FAIL_MESSAGE,
  validatePhoneNumbers,
  validateEmail,
  validateSocialMediaUrl,
  DEVELOPMENT_TYPE,
  maxLengthObjectFc,
} from "Constants";
import { isEmpty } from "BaseFunctions";
import {
  insertSpeaker,
  openSpeakerModal,
  loadSpeakerData,
  updateSpeakerImage,
  updateSpeakersFiles,
  filesChanged,
} from "ActionsSpeakers";
import { showError, showSuccess } from "ReduxErrorBar";
import { checkContentDashboardStatus } from "GeneralTabAction";
import { fetchUserList, addAppUser } from "DashboardUserAction";
import { BaseComponent } from "BaseComponent";
import InlineCropper from "InlineCropper";
import SpeakerFileUpload from "SpeakerFileUpload";
import AssociatedUsers from "./associated-users";
import { LABEL_POSITION_TOP } from "BaseComponent";
import LocaleStrings from "Languages";
var MAXLENOBJ = {};
class AddSpeaker extends BaseComponent {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.formRef = React.createRef();
    this.state = { tabKey: 1, imagedata: "", active: false };
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history); // filter This form name object With route
  }

  open() {
    this.props.loadSpeakerData({});
    this.props.reset();
    this.props.openSpeakerModal({ ...this.state, showModal: true });
  }

  close() {
    var files = [
      { position: "file1", file: "", filename: "" },
      { position: "file2", file: "", filename: "" },
      { position: "file3", file: "", filename: "" },
      { position: "file4", file: "", filename: "" },
      { position: "file5", file: "", filename: "" },
    ];

    this.props.openSpeakerModal({ showModal: false, active: false });
    this.setState({ showModal: false, active: false, imagedata: "" });
    this.props.reset();
    this.props.updateSpeakersFiles(files);
    this.props.filesChanged({ ischanged: false });
    this.props.fetchUserList(this.props.session);
  }

  submitFormOn = (e) => {
    this.props.dispatch(startSubmit("AddSpeakerForm"));
    this.formRef.current.saveImage(() => {
      this.props.dispatch(submit("AddSpeakerForm"));
    });
  };

  handleSelect(key) {
    this.props.openSpeakerModal({ showModal: true, tabKey: key });
  }

  render() {
    var {
      handleSubmit,
      pristine,
      dirty,
      reset,
      submitting,
      valid,
      submit,
      imagedata,
      filechanged,
    } = this.props;
    var edit = false;

    if (this.props.initialValues.speakerid) {
      edit = true;
    }

    var disabled = !(
      (dirty && valid) ||
      (edit && pristine && this.state.active)
    );

    if (
      edit &&
      ((imagedata && imagedata != "") || (filechanged && filechanged.ischanged))
    ) {
      disabled = false;
    }

    return (
      <div>
        <Button
          className="btn-custom-blue schedule-add-button"
          onClick={this.open.bind(this)}
        >
          <img
            style={{ paddingRight: 10, paddingBottom: 3 }}
            src="../../style/images/header-icons/plus.png"
            alt="plus"
          />
          {LocaleStrings.speaker_addnew}
        </Button>
        <div>
          <Modal
            className="modal-container"
            show={this.props.showModal.showModal === true ? true : false}
            onHide={this.close}
            animation={true}
            keyboard={false}
            backdrop="static"
            dialogClassName="speakerModal"
            enforceFocus={false}
          >
            <form onSubmit={handleSubmit(submit)} encType="multipart/form-data">
              <Modal.Header>
                <div className="import-modal-title">{`${
                  edit ? `Edit` : `Add`
                } ${
                  DEVELOPMENT_TYPE === "koachify" ? `Instructor` : `Speaker`
                }`}</div>
                <button
                  type="button"
                  className="i-custom-cross-popup pull-right"
                  onClick={() => this.close()}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                    alt="close"
                  />
                </button>
              </Modal.Header>
              <Modal.Body>
                <Tabs
                  id="speaker-from-tab"
                  activeKey={this.props.showModal.tabKey}
                  onSelect={this.handleSelect}
                  className="branding-tabs mt-0"
                >
                  <Tab eventKey={1} title="Basic Details">
                    <BasicForm
                      {...this.props}
                      speaker={this.props.initialValues}
                      session={this.props.session}
                      onImageChange={(img) => this.setState({ active: true })}
                      ref={this.formRef}
                    />
                  </Tab>
                  <Tab eventKey={2} title="Additional Details">
                    <ContactForm {...this.props} />
                  </Tab>
                  {DEVELOPMENT_TYPE === "koachify" ? (
                    ""
                  ) : (
                    <Tab eventKey={3} title="User Permission">
                      <AssociatedUsers {...this.props} />
                    </Tab>
                  )}
                  <Tab eventKey={4} title="File Upload">
                    <SpeakerFileUpload />
                  </Tab>
                </Tabs>
              </Modal.Body>
              <Modal.Footer>
                <button
                  onClick={() => this.close()}
                  className="btn btn-custom-white"
                  type="button"
                >
                  {LocaleStrings.speaker_close}
                </button>
                <Button
                  className="btn btn-custom-blue ml-10"
                  type="button"
                  loading={submitting}
                  onClick={this.submitFormOn}
                  disabled={disabled}
                >
                  {LocaleStrings.speaker_save}
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </div>
      </div>
    );
  }
}

function validate(values) {
  // debugger;
  var errors = {};

  var requiredFields = ["firstname", "lastname"];
  var maxLengthFields = [
    "firstname",
    "lastname",
    "company",
    "position",
    "description",
  ];

  requiredFields.forEach((field) => {
    if (!values[field] || values[field].trim() === "") {
      errors[field] = "Required";
    }
  });

  if (values.createuser && (!values.email || values.email.trim() === "")) {
    errors.email = "Required";
  }

  if (values.email) {
    if (!validateEmail(values.email)) {
      errors.email = "Email is invalid!";
    }
  }
  if (values.twitter) {
    if (!validateSocialMediaUrl(values.twitter)) {
      errors.twitter = "Enter valid url e.g https://twitter.com/";
    }
  }
  if (values.linkedin) {
    if (!validateSocialMediaUrl(values.linkedin)) {
      errors.linkedin = "Enter valid url e.g https://linkedin.com/";
    }
  }
  if (values.facebook) {
    if (!validateSocialMediaUrl(values.facebook)) {
      errors.facebook = "Enter valid url e.g https://facebook.com/";
    }
  }
  if (values.instagram) {
    if (!validateSocialMediaUrl(values.instagram)) {
      errors.instagram = "Enter valid url e.g https://instagram.com/";
    }
  }

  if (values.phone) {
    if (!validatePhoneNumbers(values.phone)) {
      errors.phone = "Phone number is invalid!";
    } else if (values.phone.length < 10) {
      errors.phone = "Phone number is invalid!";
    }
  }

  /*** Max Length Validation ***/
  maxLengthFields.forEach((field) => {
    if (values[field] && MAXLENOBJ) {
      if (values[field].length > MAXLENOBJ[field]) {
        errors[field] = LocaleStrings.max_characters_left + MAXLENOBJ[field];
      }
    }
  });

  return errors;
}

function onFormSubmit(values, dispatch, props) {
  var { imagedata, filechanged, speakerfilesList } = props;
  // console.log("values :- ", values);

  if (values.hasOwnProperty("facebook") && values.facebook != null) {
    values["facebook"] = values.facebook.replaceAll(/\s/g, "");
  }
  if (values.hasOwnProperty("linkedin") && values.linkedin != null) {
    values["linkedin"] = values.linkedin.replaceAll(/\s/g, "");
  }
  if (values.hasOwnProperty("twitter") && values.twitter != null) {
    values["twitter"] = values.twitter.replaceAll(/\s/g, "");
  }
  if (values.hasOwnProperty("instagram") && values.instagram != null) {
    values["instagram"] = values.instagram.replaceAll(/\s/g, "");
  }

  values.firstname = values.firstname.trim();
  values.lastname = values.lastname.trim();
  if (values.company) {
    values.company = values.company.trim();
  }
  if (values.position) {
    values.position = values.position.trim();
  }
  if (values.email) {
    values.email = values.email.trim();
  }
  if (values.phone) {
    values.phone = values.phone.trim();
  }
  if (values.facebook) {
    values.facebook = values.facebook.trim();
  }
  if (values.linkedin) {
    values.linkedin = values.linkedin.trim();
  }
  if (values.twitter) {
    values.twitter = values.twitter.trim();
  }

  var speaker = props.initialValues;
  var data = { ...values };

  if (imagedata === "" || imagedata === "removed") {
    if (imagedata === "removed") {
      data.profileimage = null;
      data.profilethumbimage = null;
    }

    imagedata = null;
  }

  return new Promise((resolve, reject) => {
    return props.insertSpeaker(
      props.session,
      data,
      speaker,
      imagedata,
      filechanged,
      speakerfilesList,
      (result) => {
        // console.log("result :- ", result);
        if (result.error === 1) {
          props.stopSubmit("AddSpeakerForm");
          props.showError(COMMON_FAIL_MESSAGE);
          return reject(result.error);
        } else if (result.error === 2) {
          props.stopSubmit("AddSpeakerForm");
          props.showError("There was an error uploading image!");
          return reject(result.error);
        } else {
          // Check you speaker wants to add as appuser too, then add as appuser
          if (!props.toEdit && values.createuser) {
            var search = _.filter(props.userCategoryList.data, (obj) => {
              return obj.type === "speaker";
            });
            var speakerCatId = search.length > 0 ? search[0].id : null;
            var formId =
              props.eventDefautUserCheckoutForm[0].event_forms_by_eventformid
                .formid;
            var formData = JSON.parse(
              props.eventDefautUserCheckoutForm[0].event_forms_by_eventformid
                .formjson
            );

            var newFormData = [];
            _.forEach(formData, (form) => {
              var key = form.key;
              var name = form.name;
              var value = "";
              if (name === "company" && values.company) {
                value = values.company.trim();
              } else if (name === "designation" && values.position) {
                value = values.position.trim();
              } else if (name === "phonenumber" && values.phone) {
                value = values.phone;
              } else if (name === "facebook" && values.facebook) {
                value = values.facebook.trim();
              } else if (name === "twitter" && values.twitter) {
                value = values.twitter.trim();
              } else if (name === "linkedin" && values.linkedin) {
                value = values.linkedin.trim();
              } else if (name === "country" && values.country) {
                value = values.country;
              }

              if (key === "checkboxes") {
                value = [];
              }
              form.value = value;

              newFormData.push(form);
            });

            var jsonData = JSON.stringify(newFormData);

            var userbody = {
              firstname: values.firstname.trim(),
              lastname: values.lastname.trim(),
              username: values.firstname.trim() + " " + values.lastname.trim(),
              email: values.email.trim(),
              eventid: props.session.eventid,
              usercategory: speakerCatId,
              formid: formId,
              responses: jsonData,
              speakeridfk: result.speakerid,
            };

            props.addAppUser(props.session, userbody, (response) => {});
          }
          setTimeout(() => {
            props.reset();
            props.checkContentDashboardStatus(props.session);
            props.finishOperationsCallback();
            props.stopSubmit("AddSpeakerForm");
            props.showSuccess(LocaleStrings.speaker_form_success);
            props.openSpeakerModal({ showModal: false, active: false });
            return resolve(result);
          }, 2000);
        }
      }
    );
  });
}

function mapStateToProps(state) {
  var toEdit = !isEmpty(state.speaker);
  var initVals = {};
  var permittedusers = "";

  if (toEdit) {
    initVals = state.speaker;

    if (initVals.appuser_by_speakeridfk.length > 0) {
      permittedusers = JSON.stringify(initVals.appuser_by_speakeridfk);
    }
    initVals = { ...initVals, permittedusers: permittedusers };
  } else {
    initVals = { permittedusers: permittedusers };
  }

  return {
    session: state.session,
    showModal: state.speakerModal,
    toEdit,
    initialValues: initVals,
    imagedata: state.speakerImage,
    filechanged: state.speakerfilesChanged,
    speakerfilesList: state.speakerfilesList,
    CountryList: state.CountryList,
    userCategoryList: state.userCategoryList,
    eventDefautUserCheckoutForm: state.eventDefautUserCheckoutForm,
  };
}

export default connect(mapStateToProps, {
  insertSpeaker,
  openSpeakerModal,
  updateSpeakerImage,
  loadSpeakerData,
  showError,
  showSuccess,
  checkContentDashboardStatus,
  updateSpeakersFiles,
  filesChanged,
  fetchUserList,
  addAppUser,
})(
  reduxForm({
    validate,
    form: "AddSpeakerForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    onSubmit: onFormSubmit,
  })(AddSpeaker)
);

class BasicForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      imagePreviewUrl: "",
      imageAvailableForCrop: false,
    };
    this.cropperRef = React.createRef();
    this.onImageSave = this.onImageSave.bind(this);
    this.props.updateSpeakerImage("");
  }

  onImageSave = (img) => {
    this.setState({ imagePreviewUrl: img });
    this.props.updateSpeakerImage(img == "" ? "removed" : img);
  };

  saveImage = (callback) => {
    if (this.state.imageAvailable) {
      this.cropperRef.current.saveImage(callback);
    } else {
      callback();
    }
  };

  onImageChange = (imageAvailable) => {
    if (imageAvailable !== undefined) this.setState({ imageAvailable });
  };

  render() {
    let { imagePreviewUrl } = this.state;
    var { speaker, toEdit } = this.props;
    if (speaker.profileimage && speaker.profileimage) {
      imagePreviewUrl = `${BASE_IMAGES_URL}/${speaker.profileimage}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
    }

    return (
      <div className="basicform">
        <Field
          name="firstname"
          label={LocaleStrings.speaker_label_fname}
          placeholder={LocaleStrings.speaker_placeholder_fname}
          type="text"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
          maxlength={MAXLENOBJ.firstname ? MAXLENOBJ.firstname : ""}
        />
        <Field
          name="lastname"
          label={LocaleStrings.speaker_label_lname}
          placeholder={LocaleStrings.speaker_placeholder_lname}
          type="text"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
          maxlength={MAXLENOBJ.lastname ? MAXLENOBJ.lastname : ""}
        />
        {!toEdit ? (
          <Field
            name="createuser"
            label={LocaleStrings.speaker_label_createuser + " ?"}
            type="checkbox"
            component={this.renderFieldCheckbox}
          />
        ) : (
          ""
        )}
        <Field
          name="email"
          label={
            toEdit
              ? LocaleStrings.speaker_label_email
              : LocaleStrings.speaker_label_email_with_info
          }
          placeholder={LocaleStrings.speaker_placeholder_email}
          type="email"
          component={this.renderFieldText}
          mandatory="false"
          labelposition={LABEL_POSITION_TOP}
        />
        <div className="form-group">
          <div className="row">
            <label className="control-label-top col-md-12">
              {LocaleStrings.speaker_label_profile}
            </label>
            <div className="col-md-12">
              <InlineCropper
                width={640}
                height={960}
                border={10}
                onImageSave={this.onImageSave}
                onImageChange={this.onImageChange}
                imagepath={imagePreviewUrl}
                imageType="jpg"
                ref={this.cropperRef}
              />
              <div className="image-subtitle-info">
                * {LocaleStrings.speaker_label_profile_text_size}
              </div>
            </div>
          </div>
        </div>
        <Field
          name="company"
          label={LocaleStrings.speaker_label_company}
          placeholder={LocaleStrings.speaker_placeholder_company}
          type="text"
          component={this.renderFieldText}
          mandatory="false"
          labelposition={LABEL_POSITION_TOP}
          maxlength={MAXLENOBJ.company ? MAXLENOBJ.company : ""}
        />
        <Field
          name="position"
          label={LocaleStrings.speaker_label_position}
          placeholder={LocaleStrings.speaker_placeholder_position}
          type="text"
          component={this.renderFieldText}
          mandatory="false"
          labelposition={LABEL_POSITION_TOP}
          maxlength={MAXLENOBJ.position ? MAXLENOBJ.position : ""}
        />
        <Field
          name="description"
          label={LocaleStrings.speaker_label_aboutyou}
          placeholder={LocaleStrings.speaker_placeholder_aboutyou}
          mandatory="false"
          component={this.renderFieldTextarea}
          maxlength={MAXLENOBJ.description ? MAXLENOBJ.description : ""}
          labelposition={LABEL_POSITION_TOP}
        />
      </div>
    );
  }
}

class ContactForm extends BaseComponent {
  render() {
    var { CountryList } = this.props;

    var countrylist = [];
    if (CountryList && CountryList.response) {
      CountryList.response.map((item) => {
        var obj = { value: item.country, text: item.country };
        countrylist.push(obj);
      });
    }

    return (
      <div className="contactform">
        <Field
          name="phone"
          label={LocaleStrings.speaker_label_phone}
          placeholder={LocaleStrings.speaker_placeholder_phone}
          type="tel"
          component={this.renderFieldText}
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="country"
          label={LocaleStrings.speaker_label_country}
          placeholder={LocaleStrings.speaker_placeholder_country}
          component={this.renderSelect}
          labelposition={LABEL_POSITION_TOP}
          opts={countrylist}
        />
        <Field
          name="facebook"
          label={LocaleStrings.speaker_label_fb}
          placeholder={LocaleStrings.speaker_placeholder_fb}
          type="text"
          component={this.renderFieldText}
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="linkedin"
          label={LocaleStrings.speaker_label_linkedin}
          placeholder={LocaleStrings.speaker_placeholder_linkedin}
          type="text"
          component={this.renderFieldText}
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="twitter"
          label={LocaleStrings.speaker_label_twitter}
          placeholder={LocaleStrings.speaker_placeholder_twitter}
          type="text"
          component={this.renderFieldText}
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="instagram"
          label={LocaleStrings.speaker_label_instagram}
          placeholder={LocaleStrings.speaker_placeholder_instagram}
          type="text"
          component={this.renderFieldText}
          labelposition={LABEL_POSITION_TOP}
        />
      </div>
    );
  }
}
